
import Vue from "vue";
import PhonePicker from "@/components/form-components/PhonePicker.vue";
import { values } from "lodash";

export default Vue.extend({
  name: "MultiplePhonePicker",

  components: { PhonePicker },

  props: {
    value: {
      required: false,
      type: Array,
      default: () => [] as Array<any>,
    },
    label: {
      required: false,
      type: String,
      default: "",
    },
    dense: {
      required: false,
      type: Boolean,
      default: false,
    },
    outlined: {
      required: false,
      type: Boolean,
      default: false,
    },
    clearable: {
      required: false,
      type: Boolean,
      default: false,
    },
    defaultCountry: {
      required: false,
      type: String,
      default: "MD",
    },
    errorMessages: {
      required: false,
      type: Array,
      default: () => [] as Array<any>,
    },
    rules: {
      required: false,
      type: Array,
      default: () => [] as Array<any>,
    },
  },

  data: () => ({
    values: [] as Array<string>,
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        if (Array.isArray(this.values)) {
          for (const value of this.value) {
            if (
              value &&
              value.hasOwnProperty("value") &&
              !this.values.includes(value.value)
            ) {
              this.values.push(value.value);
            } else if (value && !this.values.includes(value as any)) {
              this.values.push(value as any);
            }
          }
        }
      },
    },
  },

  methods: {
    changeData(): void {
      this.$emit(
        "input",
        this.values.filter((item) => item)
      );
    },
    addNumber() {
      this.values.push("");
    },
    removeItem(index: number) {
      this.values.splice(index, 1);
      this.changeData();
    },
  },
});
